module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"display_by_product":"By Products","search_placeholder":"Review keyword search"}}')
  delete Component.options._Ctor
}
